// @ts-nocheck
import BoniLogoFullIcon from "./customIcons/boni-logo-full.svg?react";
import BoniLogoIcon from "./customIcons/boni-logo.svg?react";
import CustomCheck from "./customIcons/custom-check.svg?react";
import DivergentArrowOutlineIcon from "./customIcons/divergent_arrows-outline.svg?react";
import DivergentArrowIcon from "./customIcons/divergent_arrows.svg?react";
import FidelityIcon from "./customIcons/fidelity.svg?react";
import SaleOutlineIcon from "./customIcons/sale-outline.svg?react";
import SaleIcon from "./customIcons/sale.svg?react";
import StoreRemoveOutlineIcon from "./customIcons/store_remove-outline.svg?react";
import StoreRemoveIcon from "./customIcons/store_remove.svg?react";
import CustomUserIcon from "./customIcons/user.svg?react";
import WhatsappIcon from "./customIcons/whatsapp.svg?react";
import DownloadFileOutlineIcon from "./customIcons/download_file-outline.svg?react";
export const commonIcons = {
    info: {
        alt: "Ícone de indicação de informação.",
    },
    search: {
        alt: "Ícone de representatividade de busca. Símbolo de lupa.",
    },
    help: {
        alt: "Ícone de representatividade de atenção. Símbolo de exclamação dentro de uma forma circular.",
    },
    question_mark: {
        alt: "Ícone de representatividade de dúvida. Símbolo de interrogação dentro de uma forma circular.",
    },
    call: {
        alt: "Ícone de representatividade de contato. Símbolo de telefone.",
    },
    forum: {
        alt: "Ícone de representatividade de conversa. Símbolo de dois balões de diálogo sobrepostos.",
    },
    mail: {
        alt: "Ícone de representatividade de email. Símbolo de carta retangular.",
    },
    schedule: {
        alt: "Ícone de representatividade de horário. Símbolo de relógio de ponteiro redondo.",
    },
    visibility: {
        alt: "Ícone de indicação de visibilidade. Símbolo de olho.",
    },
    visibility_off: {
        alt: "Ícone de indicação de visibilidade. Símbolo de olho.",
    },
    deployed_code_alert: {
        alt: "Ícone de indicação de alerta. Símbolo de caixa com alerta.",
    },
    check: {
        alt: "Ícone de indicação de checagem positiva.",
    },
    close: {
        alt: "Ícone de indicação de ação de fechar. Símbolo do algarismo xís.",
    },
    cancel: {
        alt: "Ícone de indicação de ação de fechar. Símbolo do algarismo xís.",
    },
    error: {
        alt: "cone de indicação de atenção. Símbolo do algarismo exclamação.",
    },
    live_help: {
        alt: "Ícone de representatividade de dúvida. Símbolo de interrogação dentro de um balão de comentário.",
    },
    groups: {
        alt: "Ícone de representatividade de pessoas. Símbolo de um grupo de três pessoas uma ao lado da outra.",
    },
    person: {
        alt: "Ícone de representatividade de uma pessoa. Símbolo de uma pessoa.",
    },
    menu: {
        alt: "Ícone de indicação de menu. Símbolo de três traços empilhados.",
    },
    check_circle: {
        alt: "Ícone de indicação de checagem positiva.",
    },
    more_vert: {
        alt: "Ícone de indicação de opções ocultas.",
    },
    store: {
        alt: "Ícone de representatividade de uma farmácia. Símbolo de estabelecimento.",
    },
    local_shipping: {
        alt: "Ícone de representatividade de distribuidores. Símbolo de um caminhão.",
    },
    domain: {
        alt: "Ícone de representatividade de farmácia. Símbolo prédio.",
    },
    shopping_cart: {
        alt: "Ícone de representatividade de carrinho de compras. Símbolo de um carrinho de supermercado.",
    },
    add_circle: {
        alt: "Ícone de representatividade de adição. Símbolo de mais dentro de um circulo.",
    },
    do_not_disturb_on: {
        alt: "Ícone de representatividade de redução. Símbolo de menos dentro de um circulo.",
    },
    logout: {
        alt: "Ícone de representatividade da ação de sair da sessão logada anteriormente.",
    },
    filter_list: {
        alt: "Ícone de indicação de filtro. Símbolo de um fúnil simbolizando possibilidade de filtrar os itens.",
    },
    warning: {
        alt: "Ícone de indicação de alerta. Símbolo de um ponto de exclamação dentro de um triangulo.",
    },
    lock: {
        alt: "Ícone de indicação de cadeado.",
    },
    history: {
        alt: "Ícone de indicação de histórico.",
    },
    delete: {
        alt: "Ícone de indicação de exclusão. Símbolo de um ponto de uma lixeira.",
    },
    calendar_month: {
        alt: "Ícone de indicação de calendário de datas. Símbolo de uma agenda com datas no centro.",
    },
    edit_square: {
        alt: "Ícone de indicação de edição. Símbolo de um lápis dentro de um quadrado.",
    },
    person_add: {
        alt: "Ícone de indicação de adicionar contas. Símbolo de um operador + com um usuário.",
    },
    manage_accounts: {
        alt: "Ícone de indicação de configuração. Símbolo de um ícone de engrenagem com um usuário.",
    },
    passkey: {
        alt: "Ícone de indicação de configuração de uma chave. Símbolo de uma chave com um usuário.",
    },
    link_off: {
        alt: "Ícone de indicação de link inativo.",
    },
    upload_file: {
        alt: "Ícone de indicação de upload de arquivo. Símbolo de uma folha com uma seta apontada para cima.",
    },
    file_copy: {
        alt: "Ícone de indicação de uma folha sobre a outra. Símbolo de uma folha sobreposta a outra.",
    },
    rocket_launch: {
        alt: "Ícone de indicação de um foguete lançado. Símbolo de um foguete após seu lançamento.",
    },
    content_copy: {
        alt: "Ícone de indicação de ação de cópia. Símbolo de duas folhas sobrepostas.",
    },
    hotel_class: {
        alt: "Ícone de indicação de um estrela cadente.",
    },
    shopping_basket: {
        alt: "Ícone de indicação de uma cesta recebendo conteúdo.",
    },
    add_business: {
        alt: "Ícone de indicação de uma loja de mercadorias",
    },
    emoji_objects: {
        alt: "Ícone de indicação de uma lampada acesa.",
    },
    autorenew: {
        alt: "Ícone de indicação de atualização. Símbolo de duas flechas em movimento circular.",
    },
    fiber_manual_record: {
        alt: "Símbolo circular.",
    },
    change_history: {
        alt: "Símbolo de triangulo.",
    },
    target: {
        alt: "Símbolo de alvo circular.",
    },
    local_activity: {
        alt: "Símbolo de ingresso.",
    },
    monitor: {
        alt: "Símbolo de monitor de computador de mesa.",
    },
    featured_seasonal_and_gifts: {
        alt: "Ícone de indicação de presente. Caixa com um laço em volta amarrado em formato de orelha de coelho.",
    },
    emoji_events: {
        alt: "Ícone de troféu.",
    },
    database: {
        alt: "Ícone de indicação de pilha de dados. pode ser usado para indicar uma pilha de moedas, ou fichas.",
    },
    diversity_3: {
        alt: "Ícone de indicação de grupo de pessoas. Ícone com três pessoas, de mãos dadas.",
    },
    brightness_alert: {
        alt: "Ícone de indicação de alerta.",
    },
    edit: {
        alt: "Ícone de indicação de ação de edição.",
    },
    arrow_downward: {
        alt: "Ícone de indicação de diminuição.",
    },
    checklist: {
        alt: "Ícone de indicação de conclusão de itens de uma lista.",
    },
    palette: {
        alt: "Ícone de paleta de cores, godê.",
    },
    browse: {
        alt: "Ícone de grid de elementos.",
    },
    format_list_bulleted: {
        alt: "Ícone de lista de elementos.",
    },
    // to see get new icons see https://fonts.google.com/icons
};
export const arrowIcons = {
    expand_circle_up: {
        alt: "Ícone de seta para cima.",
    },
    expand_circle_down: {
        alt: "Ícone de seta para baixo.",
    },
    chevron_left: {
        alt: "Ícone de indicação de posição. Símbolo de seta apontando para esquerda.",
    },
    chevron_right: {
        alt: "Ícone de indicação de posição. Símbolo de seta apontando para direita.",
    },
    chevron_down: {
        alt: "Ícone de indicação de posição. Símbolo de seta apontando para baixo.",
    },
    expand_more: {
        alt: "Ícone de indicação de posição. Símbolo de seta apontando para baixo.",
    },
    expand_less: {
        alt: "Ícone de indicação de posição. Símbolo de seta apontando para cima.",
    },
    arrow_upward_alt: {
        alt: "Ícone de indicação de posição. Símbolo de seta apontando para cima.",
    },
    arrow_downward_alt: {
        alt: "Ícone de indicação de posição. Símbolo de seta apontando para baixo.",
    },
    arrow_left_alt: {
        alt: "Ícone de indicação de posição. Símbolo de seta apontando para esquerda.",
    },
    arrow_right_alt: {
        alt: "Ícone de indicação de posição. Símbolo de seta apontando para direita.",
    },
    arrow_circle_left: {
        alt: "Ícone de indicação de posição. Símbolo de seta apontando para esquerda.",
    },
    arrow_circle_right: {
        alt: "Ícone de indicação de posição. Símbolo de seta apontando para direita.",
    },
    swap_vert: {
        alt: "Ícone de indicação de setar ordenadas. Símbolo de setas apontando para cima e para baixo.",
    },
};
export const customIcons = {
    customUser: {
        source: { default: CustomUserIcon },
        alt: "Ícone de representatividade de uma pessoa. Símbolo de uma pessoa.",
    },
    fidelity: {
        source: { default: FidelityIcon },
        alt: "Ícone de representatividade de parceria e fidelidade. Símbolo de mãos dadas fazendo um símbolo de coração.",
    },
    sale: {
        source: {
            fill: {
                true: SaleIcon,
                false: SaleOutlineIcon,
            },
        },
        alt: "Ícone de indicação de desconto.",
    },
    storeRemove: {
        source: {
            fill: {
                true: StoreRemoveIcon,
                false: StoreRemoveOutlineIcon,
            },
        },
        alt: "Ícone de representatividade de uma farmácia não encontrada. Símbolo de estabelecimento.",
    },
    divergentArrow: {
        source: {
            fill: {
                true: DivergentArrowIcon,
                false: DivergentArrowOutlineIcon,
            },
        },
        alt: "Ícone de representatividade de troca. Simbolo de duas setas apontando para lados opostos.",
    },
    whatsapp: {
        source: { default: WhatsappIcon },
        alt: "Ícone do WhatsApp. Símbolo de um telefone dentro de uma balão de conversa.",
    },
    boniLogo: {
        source: { default: BoniLogoIcon },
        alt: "Ícone de representatividade de parceria e fidelidade. Símbolo de letra B em formato de coelho na cor roxa.",
    },
    boniLogoFull: {
        source: { default: BoniLogoFullIcon },
        alt: "Ícone de representatividade de parceria e fidelidade. Palavra Boni escrita por extenso com um ponto no final, e a letra B em formato de coelho na cor roxa.",
    },
    customCheck: {
        source: { default: CustomCheck },
        alt: "Ícone de indicação de checagem positiva.",
    },
    downloadFile: {
        source: {
            fill: {
                true: DownloadFileOutlineIcon,
                false: DownloadFileOutlineIcon,
            }
        },
        alt: "Ícone de indicação de download de arquivo. Símbolo de uma folha com uma seta apontada para baixo.",
    },
};
export const icons = {
    ...customIcons,
    ...arrowIcons,
    ...commonIcons,
};
//# sourceMappingURL=helpers.js.map